// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__fedraSansStd_52900d', '__fedraSansStd_Fallback_52900d'"},"className":"__className_52900d","variable":"__variable_52900d"};